import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslatorService } from '../../../../services/translator_service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RTLDivDirectiveDirective } from '../../../../directives/rtldiv-directive.directive';
import { MatTableModule } from '@angular/material/table';
import { TranslatePipe } from '@ngx-translate/core';
import { DialogData } from '../install-new-bin';

export interface PeriodicElement {
  item: string;
  value: any;
}

const ELEMENT_DATA: PeriodicElement[] = [];

@Component({
  selector: 'app-install-new-bin-dialog',
  imports: [TranslatePipe,CommonModule,FormsModule, RTLDivDirectiveDirective,MatDialogModule,MatTableModule],
  templateUrl: './install-new-bin-dialog.html',
  styleUrl: './install-new-bin-dialog.scss',
})
export class InstallNewBinDialog {
  displayedColumns: string[] = ['item', 'value'];
  dataSource = ELEMENT_DATA;
  isSwap: boolean;
  isInstallationCompleted: boolean;
  binId: number;
  currentLang: string;
  translateSub;
  translationsObj;

  constructor(
    public dialogRef: MatDialogRef<InstallNewBinDialog>,private translator: TranslatorService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { 
      this.currentLang = this.translator.getTranslationLanguage();      
      this.translateSub = this.translator.getTranslation(this.currentLang).subscribe(translations => {
        this.translationsObj = translations;
      });
    }

  ngOnInit() {
    this.isSwap = this.data.isSwap;
    this.isInstallationCompleted = this.data.isInstallationCompleted;
    if (this.isInstallationCompleted) this.binId = this.data.binId;

    ELEMENT_DATA.length = 0;
    for (let key in this.data.data) {
      let newName = {
        item: key,
        value: this.data.data[key]
      };
      ELEMENT_DATA.push(newName);
    }
  }
}
